import { Preference } from '../../../avisDePub/preferences-avis-de-pub/model/preference';
import { takeUntil } from 'rxjs/operators';
import { SelectPreferenceComponent } from '../../modals/select-preference/select-preference.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreferenceType } from '../../models/enum/preferenceType';
import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-star-preference',
  templateUrl: './star-preference.component.html',
  styleUrls: ['./star-preference.component.scss']
})
export class StarPreferenceComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  @Input() preferenceType: PreferenceType;
  @Output() preferenceSelected = new EventEmitter<Preference>();

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  chargePreference(){
    const modalRef = this.modalService.open(SelectPreferenceComponent);
    modalRef.componentInstance.preferenceType = this.preferenceType;
    modalRef.componentInstance.preferenceSelected.pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: (data => {
        this.preferenceSelected.emit(data);
      })
    });
  }
}
